import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useApiClient } from './useApiClient';
import { useIdentity } from '../providers/IdentityProvider';
import { Device, reviveDevice } from '../types/device';

export const useDevice = (): UseQueryResult<Device> => {
  const apiClient = useApiClient();
  const { id } = useIdentity();

  return useQuery({
    queryKey: ['devices', id],
    queryFn: ({ queryKey: [, id] }) =>
      apiClient.public.devices
        .get(id ?? '')
        .then((device) => reviveDevice(device)),
    enabled: !!id,
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    networkMode: 'always',
    refetchOnReconnect: true,
  });
};
